import { animated } from '@react-spring/web'
import { CircleProps } from '../models'

export default function Circle({ x, y, r, fill, opacity }: CircleProps) {
  return <animated.circle cx={x} cy={y} r={r} fill={fill} opacity={opacity} />
}
